export default __webpack_public_path__ + "static/media/ocean-import-light.19563c24.svg";